module.exports = __webpack_public_path__ + "img/quote-left.ce65bc52.svg";